module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_IncidentResponse.81036a16.svg";